<meta name="viewport" content="width=device-width, initial-scale=1.0">
<div class="maintenance p-[1.5em]  flex flex-col justify-start items-center absolute">
  <div class="flex flex-col justify-center w-[8em] h-[4em] overflow-hidden ">
    <app-orca-logo [divStyling]="'logo-maintenance'" [logoType]="'black'" (click)="back()"/>
  </div>
  <div class="maintenance-container flex flex-col items-center self-stretch ">
    <div class="maintenance-image max-w-[40em] w-[100%]">
      <img src="../assets/svg/common/maintenance.svg" alt="maintenance">
    </div>
    <div class="maintenance-title-subtitle font-1p32813em max-w-[28em]">
      <div class="bold600">{{TITLE}}</div>
      <span class="font-0p9375em line-height-140 ">{{SUB_TITLE}}</span>
    </div>
  </div>
</div>
